











































import { Vue, Component } from 'vue-property-decorator';

@Component
export default class DaysCalculator extends Vue {
  calculatorOptions = [
    {
      label: 'Days Until',
      description: 'Calculate the days between two dates'
    },
    {
      label: 'Countdown',
      description: 'Calculate the '
    }
  ]
}
